module.exports = {
  'Lane Crawford': '5d309af9ad911a19c070bcc0',
  Demo: '5e78cc935a25538b2b8ea65e',
  'H&M': '5d8b964aad911a2894b48f86',
  Maxmara: '5e84627547710f17806d7f52'
}
